import { render, staticRenderFns } from "./video-calibration-speed-page.vue?vue&type=template&id=2a905fb7&scoped=true"
import script from "./video-calibration-speed-page.vue?vue&type=script&lang=js"
export * from "./video-calibration-speed-page.vue?vue&type=script&lang=js"
import style0 from "./video-calibration-speed-page.vue?vue&type=style&index=0&id=2a905fb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a905fb7",
  null
  
)

export default component.exports